import { render, staticRenderFns } from "./EditSpaceChild.vue?vue&type=template&id=8b683244&"
import script from "./EditSpaceChild.vue?vue&type=script&lang=js&"
export * from "./EditSpaceChild.vue?vue&type=script&lang=js&"
import style0 from "./EditSpaceChild.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports